import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Observable} from "rxjs";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import Editor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: 'app-edit-center-highlight-item',
  templateUrl: './edit-center-highlight-item.component.html',
  styleUrls: ['./edit-center-highlight-item.component.scss']
})
export class EditCenterHighlightItemComponent {

  data = inject(MAT_DIALOG_DATA)
  highlighTypeList$!: Observable<any[]>

  constructor(
    private readonly mDatabase: AngularFireDatabase,
    private readonly mDialogRef: MatDialogRef<EditCenterHighlightItemComponent>
  ) {
    this.highlighTypeList$ = mDatabase.list<any>('types/Highlights Type').valueChanges();

  }

  save() {
    if (this.data.highlight && typeof this.data.highlight === 'object') {
      alert(this.data.highlight.highlight);
      this.data.highlight = this.data.highlight.highlight; // Extract the string value
    }
    this.mDialogRef.close(this.data);
  }

  protected readonly Editor = Editor;
}
